import {useCallback} from 'react';
import type {InvitationCategoryType} from '~/common/components/MegaNav/MegaNavVariant/types';
import {Button} from '~library/atoms/Button';
import {Divider} from '~library/atoms/Divider';
import {Typography} from '~library/atoms/Typography';
import {useTracking} from '~library/context/tracking/tracking-context';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {charcoal} from '~libSass/base/_exports.sass';
import * as styles from './CategoryList.module.scss';

type CategoryListProps = {
  categories: InvitationCategoryType[];
  onCategoryClick: (category: InvitationCategoryType) => void;
};

export const CategoryList = ({categories, onCategoryClick}: CategoryListProps) => {
  const {track} = useTracking();

  const handleCategoryClick = useCallback(
    (category: InvitationCategoryType) => {
      track({
        dataQaId: category.dataQaId,
        href: category.href,
        title: category.title,
      });
      onCategoryClick(category);
    },
    [onCategoryClick, track]
  );

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        {categories.map((category) => {
          return (
            <div key={category.title}>
              <Button
                className={styles.item}
                onClick={() => handleCategoryClick(category)}
                data-qa-id={category.dataQaId}
                variant="transparent"
              >
                <Typography
                  variant="paragraph2"
                  style={{
                    color: category.linkColor || charcoal,
                  }}
                >
                  {category.title}
                </Typography>
                {category?.subCategories?.length > 0 && <ChevronIcon ratio={0.5} />}
              </Button>
              <Divider className={styles.divider} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
